import "../../sass/global.scss";

import Swiper, { EffectFade, Navigation, Pagination, Autoplay } from "swiper";
import "aos/dist/aos.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "swiper/css/autoplay";

import { ObserverFooter, stickyClose } from "../components/stickyGame";

const loader = document.querySelector(".stella-loader-overlay") as HTMLElement;

window.addEventListener("load", () => {
  pageTransition();
  pacoImagesHttpsLocal();
  menuLinksActive();
  addClassByPath("/user/login", "login-drupal");
  // handle sticky game
  ObserverFooter();
  stickyClose();
  pacoFooter();
  agegateDataLayer();
  sendDataLayer();
  abiLegal();
  menuLogin();
  sliderFritesMenu();
  removeH2();
  if (window.innerWidth >= 1024) {
    // hideLateralMenu();
    ocultarNavLeftSiFooterVisible();
    setOddElements();
  }

  // ---------------- MENU HEADER USER ICON ---------------- //
  const iconUser = document.querySelector(
    "#menu__paco .menu__login--desktop .menu-item--expanded a"
  );

  iconUser?.addEventListener("click", () => {
    window.dataLayer.push({
      event: "GAEvent",
      event_category: "Content",
      event_action: "button",
      event_label: "Perfil",
      interaction: "true",
      component_name: "btn_user_icon",
      element_text: "icono_usuario",
    });
  });
});

const pageTransition = () => {
  const isAge = document.querySelector("body.agegate-visible") as HTMLElement;

  if (!isAge) {
    setTimeout(() => {
      loader.style.transform = "translateY(-100vh)";
      loader.classList.add("hideLoader");
      setTimeout(() => {
        loader.style.transform = "translateY(100vh)";
      }, 500);
    }, 50);
  } else {
    loader.style.zIndex = "0";
    loader.style.opacity = "0";
  }

  const anchors = document.querySelectorAll(
    "a"
  ) as NodeListOf<HTMLAnchorElement>;
  anchors.forEach((anchor) => {
    const userIcon = anchor?.classList?.contains("nav-link--user-login");
    const noUserIcon = anchor?.classList?.contains("nav-link--user-logout");
    if (userIcon || noUserIcon) return;

    if (anchor.target === "_blank") return;
    anchor.addEventListener("click", () => {
      loader.style.transform = "translateY(0vh)";
      loader.classList.remove("hide");
      setTimeout(() => {
        // console.log(anchor.href);
        loader.style.transform = "translateY(-100vh)";
        loader.classList.add("hide");
        if (anchor.href && !anchor.href.includes("#")) {
          window.location.href = anchor.href;
        }
      }, 50);
    });
  });
};

const pacoImagesHttpsLocal = () => {
  window.location.protocol === "http:" &&
    setTimeout(() => {
      const imgs: NodeListOf<HTMLImageElement> =
        document.querySelectorAll('img[src*="https"]');
      imgs &&
        imgs.forEach((img) => {
          img.src = img.src.replace("https", "http");
        });
    }, 500);
};

const menuLinksActive = () => {
  const linksMenu = document.querySelectorAll(
    "#menu__paco > div.menu__paco--wrapper .item-link > a"
  ) as NodeListOf<HTMLAnchorElement>;
  linksMenu &&
    linksMenu.forEach((link) => {
      const menuActive = link.href.split("/").pop();
      menuActive !== ""
        ? location.pathname.includes(menuActive) &&
          link.classList.add("is-active")
        : null;
    });
};

const menuLogin = () => {
  // const userLink = document.querySelector('#menu__paco #loginDrupal') as HTMLAnchorElement
  const userLink = document.querySelector(
    "#menu__paco .nav-link--user-login"
  ) as HTMLAnchorElement;
  if (window.drupalSettings.user.uid <= 0) {
    if (!userLink) return;
    userLink.href = "/iniciar-sesion";
  } else {
    const userLogout = document.querySelector(
      "#menu__paco .dropdown a.nav-link"
    ) as HTMLAnchorElement;
    if (userLogout) {
      userLogout.href = "";
    }

    const userIcon = document.querySelector(".userMenu__header--icon");
    userIcon.textContent = `${window.drupalSettings.user.name[0]}${window.drupalSettings.user.lastname[0]}`;
    const userName = document.querySelector(".userMenu__header--user");
    userName.textContent = `${window.drupalSettings.user.name} ${window.drupalSettings.user.lastname}`;

    if (userLogout) {
      userLogout.addEventListener("click", (e) => {
        e.preventDefault();
        // const urlLogout = '/user/logout'
        const menuUser = document.querySelector(".userMenu") as HTMLElement;
        // render user name

        // link active
        const linksMenu = document.querySelectorAll(
          ".userMenu--item > a"
        ) as NodeListOf<HTMLAnchorElement>;
        linksMenu &&
          linksMenu.forEach((link) => {
            const menuActive = link.href.split("/").pop();

            if (location.pathname === "/") {
              linksMenu[1].parentElement.classList.add("active");
              return;
            }

            if (menuActive.length > 1) {
              if (location.pathname.includes(`/${menuActive}`))
                link.parentElement.classList.add("active");
            }
            // ? null : location.pathname.includes(menuActive) ? link.parentElement.classList.add('active') : null

            // menuActive === '' ? linksMenu[1].parentElement.classList.add('active')  link.parentElement.classList.add('active') :
          });
        menuUser.classList.toggle("is-open");
        // userMenu--item active
      });
    }
  }
};

const pacoFooter = () => {
  // logo redirect
  const imgLogo = document.querySelector(
    ".paco__main--subscription-brand-logo"
  );
  imgLogo && imgLogo.addEventListener("click", () => (location.href = "/"));

  // subscribe text
  const btnSubscribe = document.querySelector(
    "#edit-ab-paco-subscribe-submit"
  ) as HTMLInputElement;
  if (btnSubscribe) btnSubscribe.value = "Suscribirme";

  // copy social menu to header
  let clicked = false;
  if (window.innerWidth <= 1023) {
    const btn = document.querySelector(".menu__header--toggle");
    btn &&
      btn.addEventListener("click", () => {
        console.log("click toogle");

        const header = document.querySelector(".menu__paco--wrapper");
        const redes = document.querySelector(".paco__main--social");
        const redesHeader = redes.cloneNode(true);
        !clicked && header.appendChild(redesHeader);
        clicked = true;
      });
  }
};

const addClassByPath = (path: string, bodyClass: string) =>
  location.pathname.includes(path) && document.body.classList.add(bodyClass);

declare global {
  interface Window {
    dataLayer: any;
  }
}

const agegateDataLayer = () => {
  // data agegate
  var ageGateValidate = localStorage.getItem("ageGateValidate");
  var ageGateDatalayer = localStorage.getItem("ageGateDatalayer");
  if (ageGateDatalayer) return;
  if (ageGateValidate) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "GAEvent",
      event_category: "Age Gate",
      event_action: "Interaction",
      event_label: `Yes`,
      interaction: "False",
      component_name: "button_continuar",
      element_text: "Continuar age gate",
    });
    localStorage.setItem("ageGateDatalayer", "true");
  }
};

const sendDataLayer = () => {
  // datalayer header items
  const headerItems = document.querySelectorAll(
    "#menu__paco .item-link a"
  ) as NodeListOf<HTMLAnchorElement>;
  headerItems.length &&
    headerItems.forEach((item) => {
      item.addEventListener("click", () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "GAEvent",
          event_category: "Content",
          event_action: "Content",
          event_label: 'Menu-Superior',
          interaction: `true`,
          component_name: "Menu-Superior",
          element_text: `${item.textContent}`,
        });
      });
    });

  //dataLayer boton Abrir Juego
  const stickyGame = document.querySelector(".stickyGame");
  if (stickyGame) {
    stickyGame.addEventListener("click", () => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "GAEvent",
        event_category: "Content",
        event_action: "Content",
        event_label: `Jugar`,
        interaction: "true",
        component_name: "Jugar Botón Flotante",
        element_text: "Jugar",
      });
    });
  }
};

const abiLegal = () => {
  const body = document.querySelector("body");
  const legalItem = document.querySelector("#block-abilegaltext");
  if (body.classList.contains("agegate-visible")) {
    if (legalItem) {
      const footer = document.querySelector("#footer");
      footer.insertAdjacentElement("afterbegin", legalItem);
    }
  }

  // const btnAbiLegal = legalItem.querySelector('.legal_accordion')
  // btnAbiLegal.addEventListener('click', () => {
  //   btnAbiLegal.classList.toggle("active");
  //   var panel = btnAbiLegal.nextElementSibling as HTMLElement
  //   if (panel.style.display === "block") {
  //     panel.style.display = "none";
  //   } else {
  //     panel.style.display = "block";
  //   }
  // })
};

function sliderFritesMenu() {
  const swipper_menu_frites = new Swiper(".menu_slider", {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 3,
    spaceBetween: 0,
    loop: false,
    speed: 500,
    allowSlideNext: true,
    allowSlidePrev: true,
    autoplay: {
      delay: 4000,
      // disableOnInteraction: false,
    },
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1.1,
        spaceBetween: 5,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 1,
        spaceBetween: 5,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 1,
        spaceBetween: 5,
      },

      980: {
        slidesPerView: 1.5,
        spaceBetween: 10,
      },

      1280: {
        slidesPerView: 3,
        spaceBetween: 5,
      },
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      renderBullet: (index, className) =>
        `<span class="bullet-loader bullet-animation ${className}"><svg class="svg"><circle r="11" cx="12" cy="12"/></svg></span>`,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

const setOddElements = () => {
  const elements = document.querySelectorAll(".swiper-slide");
  elements.forEach((element, index) => {
    if (index % 2 !== 0) {
      element.classList.add("impar");
    }
  });
};

const removeH2 = () => {
  var divToRemove = document.getElementById("block-abpacoheader-menu");
  divToRemove.remove();
};

function ocultarNavLeftSiFooterVisible(): void {

  let url = window.location.href;
  let stringABuscar = "frites-artois";

  if (url.includes(stringABuscar)) {
    let navLeft = document.querySelector(".navLeft") as HTMLElement;
    let footer = document.querySelector("#footer") as HTMLElement;

    let observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            navLeft.style.display = "none";
          } else {
            navLeft.style.display = "flex";
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(footer);
  }
}
